import './Aboutschool.css';
import Footer from '../../components/Footer/Footer.jsx';
import ImageCard from '../../components/ImageCard/ImageCard.jsx';
import before_school from '../../images/schoolbef.jpg'
import before_school2 from '../../images/schoolbef2.jpg'
import before_school3 from '../../images/schoolbef3.jpg'
import before_school4 from '../../images/schoolbef5.jpg'
import { Link } from 'react-router';
import old1 from '../../images/Pav_star/1.jpg'
import old2 from '../../images/Pav_star/2.jpg'
import old3 from '../../images/Pav_star/3.jpg'
import old4 from '../../images/Pav_star/4.jpg'
import old5 from '../../images/Pav_star/5.jpg'
import old6 from '../../images/Pav_star/6.jpg'

  function Aboutschool() {
    return (
      <>
              <div className='wrap'>
        <div className="about-container">
          <div className="about-section">
            
            <div className="about-content">
              <h2>Прошлое территории: от церкви к школе</h2>
              <p>До революции на месте школьного спортзала стояла Покровская церковь, построенная в XVIII веке. Храм с пятью главами и трёхъярусной колокольней был центром праздничных гуляний — здесь зажиточные горожане катались на тройках от улицы Шмидта до «Воскресенской Лужи».</p>
              <p>После прихода большевиков церковь разрушили, а в 1930 году на её месте открыли школу им. В.И. Ленина. На торжественном открытии присутствовал нарком просвещения А. Луначарский. В этом здании до 1984 года располагалась школа №1.</p>
            </div>
            <div className="about-image-container">
              <img 
                src={before_school}
                className="about-image"
              />
            </div>
          </div>
          
          <hr className='section-separator'/>
          
          <div className="about-section">
            <div className="about-image-container">
              <img 
                src={before_school2} 
                alt="Школа в военные годы" 
                className="about-image"
              />
            </div>
            <div className="about-content">
              <h2>Школа в годы войны и в наше время</h2>
              <p>В сентябре 1941 года в здании разместили эвакогоспиталь №1743. Более 800 медиков работали здесь: в кабинете директора была операционная, в учительской — перевязочная, а в актовом зале — палата для выздоравливающих.</p>
            </div>
          </div>
          <hr className='section-separator'/>
          <div className="about-section">
            
            <div className="about-content">
              <h2>Как Павловское педучилище стало средней школой</h2>
              <p>История самой школы 6 началась по адресу ул. Шмидта, 32, где долгие годы было Павловское педагогическое училище. 3 июля 1955 г. здесь отгремели звуки последнего выпускного бала, а с нового учебного года в сентябре 1955 года в этих стенах открылась средняя школа №6</p>
            </div>
            <div className="about-image-container">
              <img 
                src={before_school3}
                className="about-image"
              />
            </div>
          </div>
          <hr className='section-separator'/>
          <div className="about-section">
            <div className="about-image-container">
              <img 
                src={before_school4}
                className="about-image"
              />
            </div>
            <div className="about-content">
              <h2>Алексей Шалбин и новое начало: 1985 год в летописи школы</h2>
              <p>Сентябрь 1985 года - новая значимая страница в истории школы. После капитального ремонта школа №6 располагается в здании по ул. Маяковского, дом 4. Директором школы становится Шалбин Алексей Николаевич, почетную доску которого открыли в этом году на втором этаже.</p>
            </div>
          </div>
        </div>
        <div className="next-floor-button-container butcon">
            <Link to="/" className="next-floor-button">
              На главную
            </Link>
        </div>
      </div>
      <Footer/>
      </>
    );
  }

  export default Aboutschool;